export default {"src":"/_next/static/media/step3.20e12eee.svg","height":44,"width":64};